import i18n from '@/helpers/i18n'
import { Consts } from '@/helpers/consts'

export const StudyExpensesPayerList = {
  data() {
    return {
      studyExpensesPayerList: [
        { text: i18n.instance().t('living-expenses-payer-me'), id: Consts.STUDY_EXPENSES_PAYER_ME },
        { text: i18n.instance().t('living-expenses-payer-family-member'), id: Consts.STUDY_EXPENSES_PAYER_FAMILY_MEMBER },
        {
          text: i18n.instance().t('living-expenses-payer-me-and-family-member'),
          id: Consts.STUDY_EXPENSES_PAYER_ME_AND_FAMILY_MEMBER
        },
        { text: i18n.instance().t('living-expenses-scholarship'), id: Consts.STUDY_EXPENSES_SCHOLARSHIP },
        { text: i18n.instance().t('living-expenses-payer-other'), id: Consts.STUDY_EXPENSES_PAYER_OTHER },
        { text: i18n.instance().t('living-expenses-payer-na'), id: Consts.STUDY_EXPENSES_PAYER_NA }
      ]
    }
  },
  methods: {
    getStudyExpensesPayerFacetLabel: function(studyExpensePayerFacet) {
      return `${this.studyExpensesPayerList.filter(x => x.id === studyExpensePayerFacet.value.toString()).first().text} (${
        studyExpensePayerFacet.count
      })`
    },
    getStudyExpensesPayerLabelById: function(id) {
      return this.studyExpensesPayerList.filter(x => x.id === id).first().text
    }
  }
}
